import React from 'react'
import { AppBar } from '@mui/material'
import { PortalLogo, Typography } from 'cdh-data-portal-theme'
import { useStyles } from './Topbar.style'
import { localtext } from './Topbar.static'
import { UserMenu } from './UserMenu/UserMenu'

export interface TopbarProps {
  readonly className?: string
}

export const Topbar: React.FC<TopbarProps> = ({ className }) => {
  const { classes, cx } = useStyles()

  return (
    <>
      <div className={classes.mask} />
      <AppBar className={cx(classes.appBar, className)}>
        <div className={classes.leftSection}>
          <a className={classes.brand} href="/" aria-label="CDH Operations Hub home">
            <PortalLogo withoutText />
            <Typography variant="headline2" className={classes.operationsHubText} color={'white'}> {localtext.LogoText} </Typography>
            <Typography variant="headline2" className={classes.internalWarningText}> {localtext.InternalWarning} </Typography>
          </a>
        </div>
        <div className={classes.rightSection}>
          <UserMenu />
        </div>
      </AppBar>
    </>
  )
}
